import { render } from "./Overlay.vue?vue&type=template&id=2638267c&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"

import "./Overlay.vue?vue&type=style&index=0&id=2638267c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ccjoe\\Documents\\CC2\\CareControlJobs\\FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2638267c"]])

export default __exports__